// 适用于我们协作开发时的管理（相当于每个人的模块写在这里）
const moduleB = {
    state: {
      bData: 'moduleB'
    },
    mutations: {
      moduleMutationsB(state) {
        state.bData = '更新moduleB'
      }
    },
    actions: {
      // context 上下文
      moduleMutationsB(context) {
        context.commit('moduleMutations')
      }
    },
    getters: {
      gettersOneB(state){
        return state.bData+'更新了'
      }
    }
  }
  export default moduleB